// Main cities per country, used by the social-proof purchase notifications.
// The visitor's country is resolved from their IP (with a timezone fallback),
// so the cities shown always feel local.
export const CITIES_BY_COUNTRY: Record<string, string[]> = {
  AR: ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Santiago del Estero', 'Corrientes', 'Posadas', 'Paraná', 'Bahía Blanca', 'San Salvador de Jujuy'],
  US: ['Miami', 'Houston', 'Los Ángeles', 'Nueva York', 'Chicago', 'San Antonio', 'Orlando', 'Dallas', 'Phoenix', 'San Diego', 'Denver', 'Atlanta', 'Las Vegas', 'Tampa', 'Austin', 'Charlotte', 'San José', 'Jacksonville'],
  MX: ['Ciudad de México', 'Guadalajara', 'Monterrey', 'Puebla', 'Cancún', 'Mérida', 'Querétaro', 'León', 'Tijuana', 'Toluca', 'Aguascalientes', 'San Luis Potosí', 'Chihuahua', 'Morelia', 'Oaxaca', 'Veracruz', 'Playa del Carmen', 'Hermosillo'],
  ES: ['Madrid', 'Barcelona', 'Valencia', 'Sevilla', 'Málaga', 'Bilbao', 'Zaragoza', 'Alicante', 'Murcia', 'Palma de Mallorca', 'Granada', 'Salamanca', 'Valladolid', 'Vigo', 'Gijón', 'Santander', 'San Sebastián', 'Córdoba'],
  CO: ['Bogotá', 'Medellín', 'Cali', 'Barranquilla', 'Cartagena', 'Bucaramanga', 'Pereira', 'Santa Marta', 'Manizales', 'Cúcuta', 'Ibagué', 'Villavicencio', 'Pasto', 'Armenia', 'Neiva', 'Montería'],
  PE: ['Lima', 'Arequipa', 'Cusco', 'Trujillo', 'Chiclayo', 'Piura', 'Iquitos', 'Huancayo', 'Tacna', 'Cajamarca', 'Puno', 'Ayacucho', 'Ica', 'Chimbote', 'Juliaca', 'Sullana'],
  CL: ['Santiago', 'Valparaíso', 'Viña del Mar', 'Concepción', 'Antofagasta', 'La Serena', 'Temuco', 'Rancagua', 'Puerto Montt', 'Iquique', 'Talca', 'Arica', 'Chillán', 'Valdivia', 'Osorno', 'Copiapó'],
  EC: ['Quito', 'Guayaquil', 'Cuenca', 'Ambato', 'Manta', 'Loja', 'Riobamba', 'Machala', 'Portoviejo', 'Esmeraldas', 'Ibarra', 'Santo Domingo', 'Latacunga', 'Babahoyo'],
  UY: ['Montevideo', 'Salto', 'Punta del Este', 'Paysandú', 'Maldonado', 'Rivera', 'Las Piedras', 'Tacuarembó', 'Melo', 'Colonia del Sacramento', 'Mercedes', 'Durazno'],
  PY: ['Asunción', 'Ciudad del Este', 'San Lorenzo', 'Luque', 'Capiatá', 'Lambaré', 'Fernando de la Mora', 'Encarnación', 'Pedro Juan Caballero', 'Coronel Oviedo', 'Itauguá'],
  BO: ['Santa Cruz de la Sierra', 'La Paz', 'Cochabamba', 'El Alto', 'Sucre', 'Oruro', 'Tarija', 'Potosí', 'Trinidad', 'Montero', 'Quillacollo'],
  VE: ['Caracas', 'Maracaibo', 'Valencia', 'Barquisimeto', 'Maracay', 'Ciudad Guayana', 'Maturín', 'Barcelona', 'San Cristóbal', 'Mérida', 'Cumaná', 'Puerto La Cruz'],
  CR: ['San José', 'Alajuela', 'Cartago', 'Heredia', 'Liberia', 'Puntarenas', 'Limón', 'Escazú', 'Desamparados', 'Pérez Zeledón'],
  PA: ['Ciudad de Panamá', 'San Miguelito', 'Colón', 'David', 'La Chorrera', 'Santiago', 'Arraiján', 'Penonomé', 'Chitré', 'Boquete'],
  GT: ['Ciudad de Guatemala', 'Quetzaltenango', 'Antigua Guatemala', 'Escuintla', 'Villa Nueva', 'Mixco', 'Cobán', 'Huehuetenango', 'Chimaltenango', 'Petén'],
  SV: ['San Salvador', 'Santa Ana', 'San Miguel', 'Soyapango', 'Santa Tecla', 'Mejicanos', 'Apopa', 'Sonsonate', 'Ahuachapán', 'La Libertad'],
  HN: ['Tegucigalpa', 'San Pedro Sula', 'La Ceiba', 'Choloma', 'El Progreso', 'Comayagua', 'Puerto Cortés', 'Danlí', 'Choluteca', 'Siguatepeque'],
  NI: ['Managua', 'León', 'Masaya', 'Granada', 'Chinandega', 'Matagalpa', 'Estelí', 'Jinotega', 'Bluefields', 'Rivas'],
  DO: ['Santo Domingo', 'Santiago de los Caballeros', 'La Romana', 'Punta Cana', 'San Pedro de Macorís', 'Puerto Plata', 'San Cristóbal', 'Higüey', 'Moca', 'Bávaro'],
  PR: ['San Juan', 'Bayamón', 'Carolina', 'Ponce', 'Caguas', 'Mayagüez', 'Guaynabo', 'Arecibo', 'Toa Baja', 'Humacao'],
  CU: ['La Habana', 'Santiago de Cuba', 'Camagüey', 'Holguín', 'Santa Clara', 'Guantánamo', 'Bayamo', 'Cienfuegos', 'Matanzas', 'Pinar del Río'],
  BR: ['São Paulo', 'Río de Janeiro', 'Brasilia', 'Salvador', 'Fortaleza', 'Belo Horizonte', 'Curitiba', 'Recife', 'Porto Alegre', 'Manaos', 'Florianópolis', 'Goiânia', 'Belém', 'Campinas'],
  CA: ['Toronto', 'Montreal', 'Vancouver', 'Calgary', 'Ottawa', 'Edmonton', 'Quebec', 'Winnipeg', 'Hamilton', 'Mississauga'],
  IT: ['Roma', 'Milán', 'Nápoles', 'Turín', 'Palermo', 'Génova', 'Bolonia', 'Florencia', 'Bari', 'Catania', 'Verona', 'Venecia'],
  FR: ['París', 'Marsella', 'Lyon', 'Toulouse', 'Niza', 'Nantes', 'Montpellier', 'Estrasburgo', 'Burdeos', 'Lille'],
  PT: ['Lisboa', 'Oporto', 'Braga', 'Coímbra', 'Faro', 'Funchal', 'Setúbal', 'Aveiro', 'Guimarães', 'Évora'],
  DE: ['Berlín', 'Múnich', 'Hamburgo', 'Colonia', 'Fráncfort', 'Stuttgart', 'Düsseldorf', 'Leipzig', 'Bremen', 'Núremberg'],
  GB: ['Londres', 'Mánchester', 'Birmingham', 'Liverpool', 'Glasgow', 'Edimburgo', 'Bristol', 'Leeds', 'Cardiff', 'Newcastle'],
  AU: ['Sídney', 'Melbourne', 'Brisbane', 'Perth', 'Adelaida', 'Camberra', 'Gold Coast', 'Newcastle', 'Hobart', 'Darwin']
};
// Sensible regional fallbacks for countries without their own list.
const EUROPE_COUNTRIES = ['NL', 'BE', 'AT', 'CH', 'CZ', 'PL', 'HU', 'SE', 'DK', 'NO', 'FI', 'IE', 'RO', 'BG', 'HR', 'SK', 'SI', 'LT', 'LV', 'EE', 'GR', 'LU', 'IS', 'MT', 'CY'];
const EUROPE_CITIES = ['Ámsterdam', 'Bruselas', 'Viena', 'Zúrich', 'Praga', 'Varsovia', 'Budapest', 'Estocolmo', 'Copenhague', 'Oslo', 'Helsinki', 'Dublín', 'Bucarest', 'Atenas', 'Ginebra', 'Rotterdam'];
// Mixed international list used when we cannot resolve the country at all.
const FALLBACK_CITIES = ['Buenos Aires', 'Ciudad de México', 'Madrid', 'Bogotá', 'Santiago', 'Lima', 'Miami', 'Barcelona', 'Guadalajara', 'Montevideo', 'Quito', 'Córdoba', 'Medellín', 'Houston', 'Valencia', 'Rosario'];
// Timezone -> country, used when the IP lookup is blocked or fails.
const TIMEZONE_COUNTRY: Record<string, string> = {
  'America/Argentina': 'AR',
  'America/Buenos_Aires': 'AR',
  'America/Mexico_City': 'MX',
  'America/Monterrey': 'MX',
  'America/Cancun': 'MX',
  'America/Tijuana': 'MX',
  'America/Bogota': 'CO',
  'America/Lima': 'PE',
  'America/Santiago': 'CL',
  'America/Guayaquil': 'EC',
  'America/Montevideo': 'UY',
  'America/Asuncion': 'PY',
  'America/La_Paz': 'BO',
  'America/Caracas': 'VE',
  'America/Costa_Rica': 'CR',
  'America/Panama': 'PA',
  'America/Guatemala': 'GT',
  'America/El_Salvador': 'SV',
  'America/Tegucigalpa': 'HN',
  'America/Managua': 'NI',
  'America/Santo_Domingo': 'DO',
  'America/Puerto_Rico': 'PR',
  'America/Havana': 'CU',
  'America/Sao_Paulo': 'BR',
  'America/Toronto': 'CA',
  'America/Vancouver': 'CA',
  'Europe/Madrid': 'ES',
  'Europe/Lisbon': 'PT',
  'Europe/Rome': 'IT',
  'Europe/Paris': 'FR',
  'Europe/Berlin': 'DE',
  'Europe/London': 'GB',
  'Australia/Sydney': 'AU'
};
export function getCitiesForCountry(countryCode: string | null): string[] {
  if (!countryCode) return FALLBACK_CITIES;
  const code = countryCode.toUpperCase();
  if (CITIES_BY_COUNTRY[code]) return CITIES_BY_COUNTRY[code];
  if (EUROPE_COUNTRIES.includes(code)) return EUROPE_CITIES;
  return FALLBACK_CITIES;
}
function countryFromTimezone(): string | null {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    if (TIMEZONE_COUNTRY[tz]) return TIMEZONE_COUNTRY[tz];
    // America/Argentina/Cordoba -> America/Argentina
    const region = tz.split('/').slice(0, 2).join('/');
    if (TIMEZONE_COUNTRY[region]) return TIMEZONE_COUNTRY[region];
    if (tz.startsWith('America/Argentina')) return 'AR';
    if (tz.startsWith('America/') && tz.includes('Indiana')) return 'US';
    if (['America/New_York', 'America/Chicago', 'America/Denver', 'America/Los_Angeles', 'America/Phoenix', 'America/Anchorage'].includes(tz)) return 'US';
    return null;
  } catch (e) {
    return null;
  }
}
const CACHE_KEY = 'nutripeques-country';
const GEO_ENDPOINTS: {
  url: string;
  read: (data: any) => string | undefined;
}[] = [{
  url: 'https://ipapi.co/json/',
  read: d => d?.country_code
}, {
  url: 'https://ipwho.is/',
  read: d => d?.country_code
}, {
  url: 'https://get.geojs.io/v1/ip/country.json',
  read: d => d?.country
}];
// Resolves the visitor's country from their IP, falling back to their timezone.
export async function detectVisitorCountry(): Promise<string | null> {
  try {
    const cached = sessionStorage.getItem(CACHE_KEY);
    if (cached) return cached;
  } catch (e) {
    // storage unavailable — continue
  }
  for (const endpoint of GEO_ENDPOINTS) {
    try {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 3000);
      const res = await fetch(endpoint.url, {
        signal: controller.signal
      });
      clearTimeout(timer);
      if (!res.ok) continue;
      const data = await res.json();
      const code = endpoint.read(data);
      if (code && typeof code === 'string' && code.length === 2) {
        const upper = code.toUpperCase();
        try {
          sessionStorage.setItem(CACHE_KEY, upper);
        } catch (e) {
          // ignore
        }
        return upper;
      }
    } catch (e) {
      // try the next provider
    }
  }
  const fromTz = countryFromTimezone();
  if (fromTz) {
    try {
      sessionStorage.setItem(CACHE_KEY, fromTz);
    } catch (e) {
      // ignore
    }
  }
  return fromTz;
}
